module.exports = __webpack_public_path__ + "img/BrewOL.2caf9bce.jpg";